<section class="vh-100" style="padding-top: 10%;">
    <div class="container py-5 h-100">
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-12 col-md-8 col-lg-6 col-xl-5">
          <div class="card shadow-2-strong" style="border-radius: 1rem;">
            <div class="card-body p-5 text-center">
  
              <h3 class="mb-5">Sign in</h3>
  
              <div class="form-group">
                <label>Username:</label>
                <input class="form-control" name="Username"  type="text"  [(ngModel)]="Username" required placeholder="Enter Username" />
              </div>

  
              <div class="form-group">
                <label>Password:</label>
                <input class="form-control" name="Password"  type="password"  [(ngModel)]="Password" required placeholder="Enter Password" />
              </div>
  
              <button class="btn btn-primary btn-lg btn-block" type="submit" [disabled]="!Username || !Password" (click)="Login()">Login</button>
  
         
  
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


  <!--Error popup-->
<div style="float: right;margin-left:20px;">
  <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
  </button>
</div>
 <ng-template #content let-modal ID="Errormessage">
      <div class="modal-header">
          <h4 class="modal-title" 
              id="modal-basic-title">
              {{PopupTitle}}
          </h4>
          <button type="button" class="close"
                  aria-label="Close" (click)=
                  "modal.dismiss('Cross click')">
    
              <span aria-hidden="true">
                  ×
              </span>
          </button>
      </div>
      <div class="modal-body">
          <form>
              <div class="form-group">
                  <label for="dateOfBirth">
                      {{DisplayErrormessage}}
                  </label>
              </div>
          </form>
      </div>
      <div class="modal-footer">
          <button type="button" 
              class="btn btn-success btn-lg btn-block" 
              (click)="modal.close('Save click')">
              Done
          </button>
      </div>
  </ng-template>